import React from 'react'
import PropTypes from 'prop-types'
import Button from 'portal-modules/common/components/Button'
import { RpModal } from 'portal-modules/common/components/modals'
import { Form } from '@entrata/portals-common/lib/components/forms'
import { TextField,RadioGroup } from '@entrata/portals-common/lib/boxed-fields'

import styled from '@emotion/styled'
import { RadioButton } from 'portal-modules/common/components/radio-button'
import { RoundedChecklistField } from "portal-modules/common/components/checkbox";

const StyledLabel = styled('label')`
  display: block;
  font-size: 18px;
  margin-bottom: 24px;
`

const StyledButtonsWrapper = styled('div')`
  display: flex;
  justify-content: center;
  margin: 32px 0 16px;

  button {
    @media screen and (min-width: 300px) {
      width: auto;
    }

    :last-child {
      margin-left: 8px;
    }
  }
`

const DigitalSignatureModal = ({ name, label, onSubmit, title, ...props }) => {

    const filterValues = ( values ) => {

        let valueArr = { full_name : '', forms : '' }

        Object.keys(values).forEach(
            ( key, index ) => {
                if( key == 'full_name' ){
                    valueArr.full_name = values.full_name
                } else if( key.toString().indexOf( "forms_" ) == 0 ){
                    let arr = key.toString().split('_')
                    let [, formKey, section, sectionNumber] = key.toString().split('_')
                    let temp = {
                        [formKey.toString()] : { section : sectionNumber,
                        [sectionNumber]: {  'selected_choice' : values[key] } }
                    }
                    valueArr.forms = temp;
                }
            }
        )
        return valueArr
    }

    const getNoticeFormUIElements = (noticeForms) => {
        let formElements = []
        let radioNames = [];

        {noticeForms && Object.values(noticeForms.bm_data)?.forEach(
            ( bmform ) => {
                {
                    formElements.push(
                        Object.values( bmform.sections )?.map(
                            ( section ) => {
                                if(noticeForms.signing_procedure == 'one_page'){
                                    for( let i=0; i < noticeForms.page_data.length; i++ ){
                                        let noticeFormPage = noticeForms.page_data[i]
                                        if(noticeForms.currentPage != noticeFormPage.page_number && section.key == noticeFormPage.form_key ){
                                            return (null)
                                        }
                                    }
                                }
                                let choice1 = section.html_elements[0][0];
                                let choice2 = section.html_elements[1][0];
                                radioNames.push( {[choice1.reactName]: { value: '', required: true }} )
                                return (
                                    <>
                                        {section.label}
                                        <Form.Field name={choice1.reactName} >
                                            {fieldProps => (
                                                <RadioGroup {...fieldProps}>
                                                    {({ getItemProps }) => (
                                                        <>
                                                            <RadioButton key={section.key + 'choice1'} label={choice1.label} {...getItemProps({ value: choice1.value })} />
                                                            <RadioButton key={section.key + 'choice2'} label={choice2.label} {...getItemProps({ value: choice2.value })} />
                                                        </>
                                                    )}
                                                </RadioGroup>
                                            )}
                                        </Form.Field>
                                    </>
                                );
                            })
                    )}
            },
        )}

        return {radioNames : radioNames.reduce((a, v) => ({ ...a, ...v}), {}), UIElements : formElements};
    }

    const formElements = props.noticeForms?.bm_data && (getNoticeFormUIElements(props.noticeForms));

    return (
        <RpModal {...props}>
            <StyledLabel>{title}</StyledLabel>
            <Form initialFieldState={{ [name]: { required: true }, ...formElements?.radioNames }}>
                <Form.Field name={name}>
                    {fieldProps => <TextField label={label} {...fieldProps} />}
                </Form.Field>

                {formElements?.UIElements}

                <Form.Actions>
                    {({ hasErrors, values }) => (
                        <StyledButtonsWrapper>
                            <Button slim appearance='secondary' onClick={props.onClose}>
                                {__('Cancel')}
                            </Button>
                            <Button
                                slim
                                appearance='primary'
                                disabled={hasErrors}
                                onClick={() => {
                                    onSubmit(filterValues(values))
                                    props.onClose()
                                }}
                            >
                                {__('Save')}
                            </Button>
                        </StyledButtonsWrapper>
                    )}
                </Form.Actions>
            </Form>
        </RpModal>
    )
}

DigitalSignatureModal.propTypes = {
  // Label of the text field
  label: PropTypes.string.isRequired,
  // Name prop for the from.field
  name: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  // Function to execute on submitting form
  onSubmit: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
}

export default DigitalSignatureModal
